import { render } from "./CadastroCidadesView.vue?vue&type=template&id=202f2db9"
import script from "./CadastroCidadesView.vue?vue&type=script&lang=js"
export * from "./CadastroCidadesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__